export enum ListingEditStatus {
  PUBLISHED = "published",
  SOLD = "sold",
}
